import site from "./site.json";
import { resolveContent } from "./resolveContent";
import type { Lang, Localized } from "./resolveContent";

export type SiteContent = Localized<typeof site>;

// Resolved once at module load, not per render: both languages together are
// under 400 leaves, and stable references keep the context memo from churning.
export const contentByLanguage: Record<Lang, SiteContent> = {
  en: resolveContent(site, "en"),
  es: resolveContent(site, "es"),
};
